function sortSizes (element) {
  if (!element) return

  const items = Array.from(element.querySelectorAll('[data-sort]'))
  if (!items.length) return

  const sortOrder = [
    'XXXS',
    'XXS',
    'XS',
    'S',
    'S+',
    'S++',
    'S+++',
    'M',
    'L',
    'XL',
    'XXL',
    'XXXL',
  ]

  const sortedItems = items.map((item) => item).sort((a, b) => {
    const aValue = a.dataset.sort
    const bValue = b.dataset.sort

    // Sort the items
    if (!isNaN(aValue) && !isNaN(bValue)) {
      // Sort numerically if both values are numbers
      return aValue - bValue
    } else {
      // Otherwise, sort by the index of the `sortOrder` array
      return sortOrder.indexOf(aValue) - sortOrder.indexOf(bValue)
    }
  })

  // Iterate over the sorted items and update the DOM
  sortedItems.forEach((item) => {
    element.appendChild(item)
  })
}

function getFocusableElements (container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  )
}

document.querySelectorAll('[id^="HeaderMenu-Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button')
  summary.setAttribute('aria-expanded', 'false')

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id)
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'))
  })

  if (summary.closest('header-drawer')) return
  summary.parentElement.addEventListener('keyup', onKeyUpEscape)

  if (summary.classList.contains('hd-Banner_ItemSummary')) {
    summary.addEventListener('mouseenter', (event) => {
      closeMegaMenu()

      event.target.parentNode.setAttribute('open', true)
    })
  }

  document.querySelector('.hd-Banner_ItemsParent').addEventListener('mouseleave', (event) => {
    if (event.relatedTarget.classList.contains('hd-Banner_Nav')) {
      return
    }

    closeMegaMenu()
  })
})

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button')
  summary.setAttribute('aria-expanded', 'false')

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id)
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'))
  })

  if (summary.closest('header-drawer')) return
  summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

const trapFocusHandlers = {}

function trapFocus (container, elementToFocus = container) {
  const elements = getFocusableElements(container)
  const first = elements[0]
  const last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    ) { return }

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible')
} catch {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill () {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null
  let mouseClick = null

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false
    }
  })

  window.addEventListener('mousedown', (event) => {
    mouseClick = true
  })

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused')

    if (mouseClick) return

    currentFocusedElement = document.activeElement
    currentFocusedElement.classList.add('focused')
  }, true)
}

function pauseAllMedia () {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*')
  })
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })
  document.querySelectorAll('video').forEach((video) => video.pause())
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  })
}

function removeTrapFocus (elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

function closeMegaMenu () {
  document.querySelectorAll('[id^="HeaderMenu-Details-"][open]').forEach((openSummary) => {
    openSummary.removeAttribute('open')
  })
}

function onKeyUpEscape (event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return

  const openDetailsElement = event.target.closest('details[open]')
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector('summary')
  openDetailsElement.removeAttribute('open')
  summaryElement.setAttribute('aria-expanded', false)
  summaryElement.focus()
}

class QuantityInput extends HTMLElement {
  constructor () {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this)),
    )
  }

  onButtonClick (event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent)
  }
}

customElements.define('quantity-input', QuantityInput)

function debounce (fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function fetchConfig (type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  }
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) === 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i]
    if (value === option.value || value === option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent(`on${eventName}`, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  const method = options.method || 'post'
  const params = options.parameters || {}

  const form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (const key in params) {
    const hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (countryDomId, provinceDomId, options) {
  this.countryEl = document.getElementById(countryDomId)
  this.provinceEl = document.getElementById(provinceDomId)
  this.provinceContainer = document.getElementById(options.hideElement || provinceDomId)

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this))

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry () {
    const value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince () {
    const value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler (e) {
    const selected = this.countryEl.options[this.countryEl.selectedIndex]
    const raw = selected.getAttribute('data-provinces')
    const provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length === 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (let i = 0; i < provinces.length; i++) {
        const opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions (selector, values) {
    for (let i = 0, count = values.length; i < values.length; i++) {
      const opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

class MenuDrawer extends HTMLElement {
  constructor () {
    super()

    this.mainDetailsToggle = this.querySelector('details')

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)

    this.addEventListener('keyup', this.onKeyUp.bind(this))
    this.addEventListener('focusout', this.onFocusOut.bind(this))
    this.bindEvents()
  }

  bindEvents () {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)))
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)))
  }

  onKeyUp (event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    const openDetailsElement = event.target.closest('details[open]')
    if (!openDetailsElement) return

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement)
  }

  onSummaryClick (event) {
    const summaryElement = event.currentTarget
    const detailsElement = summaryElement.parentNode
    const isOpen = detailsElement.hasAttribute('open')
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

    function addTrapFocus () {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'))
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus)
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault()
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement)
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening')
        summaryElement.setAttribute('aria-expanded', true)
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus)
      }, 100)
    }
  }

  openMenuDrawer (summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })
    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer (event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening')
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open')
        details.classList.remove('menu-opening')
      })
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`)
      removeTrapFocus(elementToFocus)
      this.closeAnimation(this.mainDetailsToggle)
    }
  }

  onFocusOut (event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer()
    })
  }

  onCloseButtonClick (event) {
    const detailsElement = event.currentTarget.closest('details')
    this.closeSubmenu(detailsElement)
  }

  closeSubmenu (detailsElement) {
    detailsElement.classList.remove('menu-opening')
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false)
    removeTrapFocus()
    this.closeAnimation(detailsElement)
  }

  closeAnimation (detailsElement) {
    let animationStart

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        detailsElement.removeAttribute('open')
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'))
        }
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }
}

customElements.define('menu-drawer', MenuDrawer)

class HeaderDrawer extends MenuDrawer {
  openMenuDrawer (summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header')
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`)

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })

    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }
}

customElements.define('header-drawer', HeaderDrawer)

class ModalDialog extends HTMLElement {
  constructor () {
    super()
    const closeBtns = this.querySelectorAll('[id^="ModalClose-"]')
    Array.from(closeBtns).forEach(btn => {
      btn.addEventListener(
        'click',
        this.hide.bind(this),
      )
    })
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide()
      })
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide()
      })
    }
  }

  show (opener) {
    this.openedBy = opener
    const popup = this.querySelector('.template-popup')
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
    if (popup) popup.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
    window.pauseAllMedia()

    if (this.dataset.gaEl) {
      this.pushToDataLayer('open')
    }
  }

  hide () {
    document.body.classList.remove('overflow-hidden')
    this.removeAttribute('open')
    removeTrapFocus(this.openedBy)
    window.pauseAllMedia()

    if (this.dataset.gaEl) {
      this.pushToDataLayer('close')
    }
  }

  pushToDataLayer (action) {
    const modalName = this.dataset.gaVariableTitle

    if (this.dataset.gaEl === 'pdpDetailsAccordion') {
      window.dataLayer.push({
        event: 'pdp_accordion',
        pdpAccordion: {
          accordion_name: modalName,
          click_action: action,
        },
      })
    }
  }
}
customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor () {
    super()

    const button = this.querySelector('button')

    if (!button) return

    button.addEventListener('click', (event) => {
      event.preventDefault()
      const modal = document.querySelector(this.getAttribute('data-modal'))

      if (modal) modal.show(button)

      const modalId = event.currentTarget.dataset.id

      if (modalId !== 'new-size-guide') return

      const modifier = event.currentTarget.dataset.modifier
      this.setActiveSizeGuideTab(modalId, modifier)
    })
  }

  setActiveSizeGuideTab (modalId, modifier) {
    const sizeGuideModal = document.querySelector(`#PopupModal-${modalId}`)
    const sizeGuideTabs = document.querySelector('vb-tabs.size-guide_tabs')
    const sizeGuideTabButtons = sizeGuideModal.querySelectorAll('.js-size-guide_tab')
    const trueToSizeTab = [...sizeGuideTabButtons].filter(el => el.dataset.tabName === 'true-to-size')

    if (!trueToSizeTab) return

    const activeTab = modifier && modifier === 'true-to-size' ? trueToSizeTab[0] : sizeGuideTabButtons[0]
    sizeGuideTabs.setSelectedTab(activeTab)
  }
}
customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
  constructor () {
    super()
    const poster = this.querySelector('[id^="Deferred-Poster-"]')
    if (!poster) return
    poster.addEventListener('click', this.loadContent.bind(this))
  }

  loadContent () {
    window.pauseAllMedia()
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true))

      this.setAttribute('loaded', true)
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus()
    }
  }
}

customElements.define('deferred-media', DeferredMedia)

class SliderComponent extends HTMLElement {
  constructor () {
    super()
    this.scrollMultiple = { scrolling: false, endPoint: null }
  }

  connectedCallback () {
    this.init()
  }

  getSliderGap () {
    const computedStyle = window.getComputedStyle(this.slider)
    const gap = computedStyle.gap || computedStyle.columnGap || '0px'
    return parseFloat(gap) || 0
  }

  init () {
    this.slider = this.querySelector('ul')
    this.sliderItems = this.slider?.querySelectorAll(':scope > li') || []
    this.pageCount = this.querySelector('.slider-counter--current')
    this.pageTotal = this.querySelector('.slider-counter--total')
    this.prevButton = this.querySelector('button[name="previous"]')
    this.nextButton = this.querySelector('button[name="next"]')
    this.progressTrack = this.querySelector('.slider-progress')
    this.progressThumb = this.querySelector('.slider-progress-thumb')
    this.loadMoreButton = this.querySelector('button[name="load-more"]')
    this.viewLessButton = this.querySelector('button[name="view-less"]')

    if (!this.slider) return

    const resizeObserver = new ResizeObserver(() => this.initPages())
    resizeObserver.observe(this.slider)

    this.slider.addEventListener('scroll', this.update.bind(this))

    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this))
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this))
    }
    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', this.onLoadMoreButtonClick.bind(this))
    }
    if (this.viewLessButton) {
      this.viewLessButton.addEventListener('click', this.onViewLessButtonClick.bind(this))
    }

    if (this.querySelector('.slider-dots')) {
      this.renderDots()
    }
    if (this.querySelector('.slider-thumbnail-dots')) {
      this.initThumbnailDots()
    }

    if (!this.prevButton && !this.nextButton && this.progressThumb) {
      this.slider.addEventListener('scroll', this.animateProgressThumb.bind(this))
    }
  }

  initPages () {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0)
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1]

    if (sliderItemsToShow.length === 0) return

    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth)
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1

    this.update()
  }

  update (e) {
    if (!this.pageCount || !this.pageTotal) return
    const gap = this.getSliderGap()
    const slideWidthWithGap = this.sliderLastItem.clientWidth + gap
    this.currentPage = Math.round(this.slider.scrollLeft / slideWidthWithGap) + 1

    this.pageCount.textContent = this.currentPage
    this.pageTotal.textContent = this.totalPages

    this.updateDots()

    if (!this.prevButton || !this.nextButton) return

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled')
      this.prevButton.setAttribute('aria-disabled', 'true')
    } else {
      this.prevButton.removeAttribute('disabled')
      this.prevButton.removeAttribute('aria-disabled')
    }

    if (this.currentPage === this.totalPages || this.currentPage > this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled')
      this.nextButton.setAttribute('aria-disabled', 'true')
    } else {
      this.nextButton.removeAttribute('disabled')
      this.nextButton.removeAttribute('aria-disabled')
    }

    this.animateProgressThumb()
  }

  renderDots () {
    const wrapper = this.querySelector('.slider-dots')

    if (!wrapper) return

    wrapper.innerHTML = ''

    this.sliderItems.forEach((el, index) => {
      const dot = document.createElement('button')
      dot.classList.add('dot')
      dot.setAttribute('type', 'button')
      dot.setAttribute('data-index', index)
      dot.addEventListener('click', this.onDotClick.bind(this))

      const isCurrentDot = index === Number(this.pageCount.textContent)
      dot.setAttribute('aria-current', isCurrentDot)

      wrapper.appendChild(dot)
    })
  }

  initThumbnailDots () {
    const wrapper = this.querySelector('.slider-thumbnail-dots')

    if (!wrapper) return

    const thumbailDots = wrapper.querySelectorAll('.dot')

    thumbailDots.forEach((el) => {
      el.addEventListener('click', this.onDotClick.bind(this))
    })
  }

  updateDots () {
    const wrappers = this.querySelectorAll('.slider-dots, .slider-thumbnail-dots')

    if (!wrappers?.length || this.scrollMultiple.scrolling) return

    wrappers.forEach(wrapper => {
      wrapper.querySelectorAll('.dot').forEach(dotEl => {
        dotEl.setAttribute('aria-current', 'false')
      })

      const currentDot = wrapper.querySelectorAll('.dot')?.[this.currentPage - 1]

      if (!currentDot) return

      currentDot.setAttribute('aria-current', 'true')

      if (this.classList.contains('menu-drawer__carousel')) return

      if (window.innerWidth > 989) currentDot.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
    })
  }

  onDotClick (event) {
    const clickedDot = event.target.closest('.dot')
    const dotIndex = clickedDot.getAttribute('data-index')
    const gap = this.getSliderGap()
    const slideScrollPosition = (this.sliderItems[0].clientWidth + gap) * dotIndex
    this.scrollMultiple = { scrolling: true, endPoint: slideScrollPosition }
    this.querySelectorAll('.dot').forEach((dotEl, index) => {
      dotEl.setAttribute('aria-current', index.toString() === dotIndex)
    })

    const checkIfScrollToIsFinished = setInterval(() => {
      if (this.scrollMultiple.endPoint === this.slider.scrollLeft) {
        this.scrollMultiple.scrolling = false
        clearInterval(checkIfScrollToIsFinished)
      }
    }, 25)

    this.slider.scrollTo({
      left: slideScrollPosition,
    })
  }

  onButtonClick (event) {
    event.preventDefault()

    const gap = this.getSliderGap()
    const slideWidthWithGap = this.sliderLastItem.clientWidth + gap
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + slideWidthWithGap : this.slider.scrollLeft - slideWidthWithGap

    this.slider.scrollTo({
      left: slideScrollPosition,
      behavior: 'smooth',
    })
  }

  onLoadMoreButtonClick (event) {
    event.preventDefault()
    event.target.hidden = true
    this.querySelector('ul[name="secondary-product-list"]').removeAttribute('aria-hidden', 'true')
    this.querySelector('button[name="view-less"]').hidden = false
  }

  onViewLessButtonClick (event) {
    event.preventDefault()
    event.target.hidden = true
    this.querySelector('ul[name="secondary-product-list"]').setAttribute('aria-hidden', 'true')
    this.querySelector('button[name="load-more"]').hidden = false
  }

  animateProgressThumb () {
    const gap = this.getSliderGap()
    const slideWidthWithGap = this.sliderItems[0].clientWidth + gap
    const totalSliderWidth = (slideWidthWithGap * this.sliderItems.length) - gap
    const scrollLeftPercentage = this.slider.scrollLeft / totalSliderWidth
    if (this.progressThumb) this.progressThumb.style.left = `${Math.round(this.progressTrack.clientWidth * scrollLeftPercentage)}px`
  }
}

customElements.define('slider-component', SliderComponent)

class VariantSelects extends HTMLElement {
  constructor () {
    super()
    this.addEventListener('change', this.onVariantChange)
  }

  onVariantChange () {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    this.updatePickupAvailability()
    this.removeErrorMessage()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
      this.updateShareUrl()
    }
  }

  updateOptions () {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value)
  }

  updateMasterId () {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option
      }).includes(false)
    })
  }

  updateMedia () {
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`,
    )

    if (!newMedia) return
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`)
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`)
    const parent = newMedia.parentElement
    if (parent.firstChild === newMedia) return
    modalContent.prepend(newMediaModal)
    parent.prepend(newMedia)
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header')
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'))
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0
      parent.querySelector('li.product__media-item').scrollIntoView({ behavior: 'smooth' })
    })
  }

  updateURL () {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`)
  }

  updateShareUrl () {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`)
    if (!shareButton) return
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`)
  }

  updateVariantInput () {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`)
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updatePickupAvailability () {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  removeErrorMessage () {
    const section = this.closest('section')
    if (!section) return

    const productForm = section.querySelector('product-form')
    if (productForm) productForm.handleErrorMessage()
  }

  renderProductInfo () {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id)
        const source = html.getElementById(id)

        if (source && destination) destination.innerHTML = source.innerHTML

        const price = document.getElementById(`price-${this.dataset.section}`)

        if (price) price.classList.remove('visibility-hidden')
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut)
      })
  }

  toggleAddButton (disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`)
    if (!productForm) return
    const addButton = productForm.querySelector('[name="add"]')
    const addButtonText = productForm.querySelector('[name="add"] > span')

    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', 'disabled')
      if (text) addButtonText.textContent = text
    } else {
      addButton.removeAttribute('disabled')

      if (this.dataset.preorderEnable === 'true') {
        addButtonText.textContent = window.theme.translations.product.preorder || 'Pre Order'
      } else {
        addButtonText.textContent = window.variantStrings.addToCart
      }
    }
  }

  setUnavailable () {
    const button = document.getElementById(`product-form-${this.dataset.section}`)
    const addButton = button.querySelector('[name="add"]')
    const addButtonText = button.querySelector('[name="add"] > span')
    const price = document.getElementById(`price-${this.dataset.section}`)
    if (!addButton) return
    addButtonText.textContent = window.variantStrings.unavailable
    if (price) price.classList.add('visibility-hidden')
  }

  getVariantData () {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
  updateOptions () {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
    })
  }
}

customElements.define('variant-radios', VariantRadios);

(function () {
  const links = document.links
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank'
      links[i].rel = 'noreferrer noopener'
    }
  }
})()

class PredictiveSearchActivate extends HTMLElement {
  constructor () {
    super()
    this.querySelector('.hd-Drawer_SearchButton').addEventListener('click', (event) => {
      this.focusSearch()
    })
  }

  focusSearch () {
    this.querySelector('.hd-Drawer_SearchInput').focus()
  }
}
customElements.define('fostr-predictive-search', PredictiveSearchActivate)

class vbTabs extends HTMLElement {
  constructor () {
    super()

    this.tabs = []
    this.tabs = this.querySelectorAll('[role=tab]')
    this.tabsArr = [...this.tabs]
    this.tabpanels = []
    this.firstTab = null
    this.lastTab = null

    this.tabs.forEach(tab => {
      const tabcontrols = `#${tab.getAttribute('aria-controls')}`
      const tabpanel = this.querySelector(tabcontrols)
      tab.tabIndex = -1
      tab.setAttribute('aria-selected', 'false')
      this.tabpanels.push(tabpanel)
      tab.addEventListener('keydown', this.onKeydown.bind(this))
      tab.addEventListener('click', this.onClick.bind(this))

      if (!this.firstTab) {
        this.firstTab = tab
      }
      this.lastTab = tab
    })

    this.setSelectedTab(this.firstTab, false)
  }

  setSelectedTab (currentTab, setFocus) {
    if (typeof setFocus !== 'boolean') {
      setFocus = true
    }

    this.tabs.forEach((tab, i) => {
      if (currentTab === tab) {
        tab.setAttribute('aria-selected', 'true')
        tab.removeAttribute('tabindex')
        this.tabpanels[i].classList.remove('is-hidden')
        if (setFocus) {
          tab.focus()
        }
        if (this.tabpanels[i].querySelector('.tabpanel-content').scrollHeight > 110) {
          this.tabpanels[i].classList.add('expandable')
        }
      } else {
        tab.setAttribute('aria-selected', 'false')
        tab.tabIndex = -1
        this.tabpanels[i].classList.add('is-hidden')
      }
    })
  }

  setSelectedToPreviousTab (currentTab) {
    let index
    if (currentTab === this.firstTab) {
      this.setSelectedTab(this.lastTab)
    } else {
      index = this.tabsArr.indexOf(currentTab)
      this.setSelectedTab(this.tabs[index - 1])
    }
  }

  setSelectedToNextTab (currentTab) {
    let index
    if (currentTab === this.lastTab) {
      this.setSelectedTab(this.firstTab)
    } else {
      index = this.tabsArr.indexOf(currentTab)
      this.setSelectedTab(this.tabs[index + 1])
    }
  }

  onKeydown (event) {
    const tgt = event.currentTarget
    let flag = false
    switch (event.key) {
      case 'ArrowLeft':
        this.setSelectedToPreviousTab(tgt)
        flag = true
        break
      case 'ArrowRight':
        this.setSelectedToNextTab(tgt)
        flag = true
        break
      case 'Home':
        this.setSelectedTab(this.firstTab)
        flag = true
        break
      case 'End':
        this.setSelectedTab(this.lastTab)
        flag = true
        break
      default:
        break
    }

    if (flag) {
      event.stopPropagation()
      event.preventDefault()
    }
  }

  onClick (event) {
    this.setSelectedTab(event.currentTarget)
  }
}

customElements.define('vb-tabs', vbTabs)

class vbTableConversion extends HTMLElement {
  constructor () {
    super()

    this.switches = this.querySelectorAll('.table-convert_switch')

    this.switches.forEach(
      (switcher) => switcher.addEventListener('change', this.switchChange.bind(this)),
    )
  }

  switchChange (event) {
    if (event.target.getAttribute('data-metric') === 'in') {
      this.classList.remove('cm')
      this.classList.add('in')
    } else {
      this.classList.remove('in')
      this.classList.add('cm')
    }
  }
}

customElements.define('vb-table-conversion', vbTableConversion)

class baoBamContainer extends HTMLElement {
  constructor () {
    super()

    this.bamPlaylist = this.querySelector('bam-playlist')

    if (this.bamPlaylist) {
      const shadowRootExists = this.bamPlaylist.shadowRoot ? 'true' : 'false'
      this.closest('[data-bao-bam-loaded]').setAttribute('data-bao-bam-loaded', shadowRootExists)

      window.onBambuserLiveShoppingReady = widget => {
        this.closest('[data-bao-bam-loaded]').setAttribute('data-bao-bam-loaded', 'true')
      }
    }
  }
}
customElements.define('bao-bam-container', baoBamContainer)
